// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/home/carousel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/download/downloadSection.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* carousel section */

.carousel {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 2;
  /* padding: 1rem; */
  padding-top: 1rem;

  /* width: 1480.79px; */
  min-height: 616px;
  /* top: 52px; */
  /* left: 0.4px; */
  gap: 0px;
  /* border: 1px 0px 0px 0px; */
  opacity: 0px;

  .carousel_button {
    bottom: -3rem;
    left: 50%;
  }

  .dot {
    width: 8px;
    height: 8px;
    gap: 0px;
    border-radius: 10px;
    opacity: 0px;

    background-color: #ccd2d6;
    margin: 0 4px;
    cursor: pointer;
    transition: background-color 0.3s, width 0.3s, height 0.3s;
  }

  .dot.active {
    background-color: #1b9075;
    width: 26px;
    height: 8px;
  }
}

.carousel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: radial-gradient(104% 47.97% at 50% 52.03%,
      #082b23 0%,
      #10182f 100%);
  /* background: radial-gradient(104% 47.97% at 50% 52.03%, #1A9175 0%, #082B23 100%); */
  /* opacity: 0.95; */
  pointer-events: none;
  height: auto;
  min-height: 616px;
}

.carousel .carousel_content {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.carousel .carousel_content .left_content {
  /* width: 500px; */
  display: flex;
  flex-direction: column;
  height: 310px;
  top: 221px;
  left: 150px;
  /* gap: 10px; */
  border-radius: 6px;
  opacity: 0px;
  width: calc(50% - 100px);

  .left_content_text {
    /* width: 493px; */
    /* height: 168px; */
    height: auto;
    top: 221px;
    left: 150px;
    gap: 0px;
    opacity: 0px;

    font-family: Manrope;
    font-size: 42px;
    font-weight: 800;
    line-height: 56px;
    letter-spacing: -0.0025em;
    text-align: left;
    color: #2fc7a4;

    .sup_image {
      vertical-align: super;
      display: inline-block;
      /* width: 1rem;
            height: 1rem; */
      margin: 0;
    }

    span {
      color: #fff;
    }
  }

  .left_content_subtext {
    /* width: 500px; */
    /* height: 56px; */
    height: auto;
    top: 402px;
    left: 150px;
    gap: 0px;
    opacity: 0px;

    font-family: Manrope;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
  }

  .carousel_input {
    /* width: 434px; */
    height: 48px;
    /* top: 483px;
left: 150px; */
    gap: 0px;
    border-radius: 6px;
    opacity: 0px;
    background: #0d2330;
    border: 1px solid #ffffff;

    .custom_select {
      background: #0d2330;
      color: #fff;
      padding-left: 2.5rem;
      border-radius: 0.375rem;
      transition: border-color 0.2s;
      height: 100%;

      display: flex;
      align-items: center;

      /* width: 181px; */
      height: 22px;
      /* top: 496px;
            left: 166px; */
      gap: 0px;
      opacity: 0px;

      .state {
        font-family: Manrope;
        font-size: 16px;
        font-weight: 600;
        line-height: 21.86px;
        text-align: center;
      }

      .country {
        font-family: Manrope;
        font-size: 16px;
        font-weight: 400;
        line-height: 21.86px;
        text-align: center;
      }
    }

    .custom_service_btn {
      background: #0d2330;
      color: #fff;
      padding-left: 2.5rem;
      border-radius: 0.375rem;
      transition: border-color 0.2s;
      height: 100%;

      display: flex;
      align-items: center;

      /* width: 181px; */
      height: 22px;
      /* top: 496px;
            left: 166px; */
      gap: 0px;
      opacity: 0px;

      .text {
        font-family: Manrope;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
      }
    }

    .custom_select:focus {
      border-color: #34d399;
      outline: none;
    }

    .custom_button {
      cursor: pointer;
      position: absolute;
      left: 85%;
    }

    .icon_location {
      position: absolute;
      left: 0.75rem;
      top: 50%;
      transform: translateY(-50%);
      color: #34d399;
    }

    .icon_down {
      position: absolute;
      left: 45%;
      top: 50%;
      transform: translateY(-50%);
      color: #34d399;
    }
  }
}

.carousel .carousel_content .right_content {
  /* width: 744.67px; */
  height: 522.54px;
  position: relative;
  top: 120px;
  /* left: 659px; */
  gap: 0px;
  opacity: 0px;
  display: flex;
  align-items: flex-end;

  img {
    height: auto;
  }
}

.offers_section {
  .offers_head {
    h2 {
      font-family: Manrope;
      font-size: 18px;
      font-weight: 700;
      line-height: 24.59px;
      text-align: left;
      color: #1b9075;
    }

    h1 {
      font-family: Manrope;
      font-size: 32px;
      font-weight: 800;
      line-height: 32px;
      letter-spacing: -0.0025em;
      text-align: center;
      color: #22263f;
    }
  }

  .offers_body_content .card {
    /* display: flex; */
    /* gap: 3rem; */
    /* width: 360px; */
    height: auto;
    /* top: 842px;
        left: 150px; */
    opacity: 0px;
    background-color: #e1f5f4;

    .left_content {
      display: flex;
      flex-direction: column;
      /* justify-content: space-between; */
      align-items: baseline;
      gap: 1rem;

      .offer_percent {
        display: flex;

        span {
          width: 66px;
          height: 66px;
          background-color: #0d1b2a;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-weight: 700;
          font-family: Manrope;
        }

        sup {
          font-family: Manrope;
          font-size: 14px;
          font-weight: 700;
          line-height: 32px;
          text-align: left;
          color: #000000;
        }
      }

      .offer_text {
        /* width: 206px; */
        height: auto;
        top: 939px;
        left: 166px;
        gap: 0px;
        opacity: 0px;

        font-family: Manrope;
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
        text-align: left;
        color: #1b9075;
      }

      .offer_subtext {
        height: auto;
        gap: 0px;
        opacity: 0px;
        font-family: Manrope;
        font-size: 15px;
        font-weight: 500;
        line-height: 25px;
        letter-spacing: 0.25px;
        text-align: left;

        color: #373737;
      }
    }

    .right_content img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* top: 850px;
            left: 324px;
            gap: 0px;
            opacity: 0px; */
    }
  }
}

.services_section {
  /* width: 1144px; */
  /* height: 579px; */
  /* top: 1133px;
    left: 150px; */
  gap: 0px;
  opacity: 0px;
  background: #e7ecf7;

  .service_section_head {
    h2 {
      font-family: Manrope;
      font-size: 18px;
      font-weight: 700;
      line-height: 24.59px;
      text-align: center;
      color: #1b9075;
    }

    h1 {
      font-family: Manrope;
      font-size: 32px;
      font-weight: 800;
      line-height: 32px;
      letter-spacing: -0.0025em;
      text-align: center;
      color: #22263f;
    }
  }

  .service_section_body .card {
    display: flex;
    flex-direction: column;
    width: auto;
    height: auto;
    /* height: calc(100% - -4rem); */
    /* top: 1274px;
        left: 198px; */
    gap: 0px;
    opacity: 0px;
    background-color: #ffffff;
    position: relative;

    img {
      /* width: 110.67px;
      height: 115.12px; */
      top: 1288px;
      left: 925px;
      gap: 0px;
      opacity: 0px;

      height: 230px;
      width: 100%;
      margin-bottom: 10px;
    }

    .service_body {
      /* width: 233px; */
      height: auto;
      /* top: 1408px;
            left: 222px; */
      gap: 0px;
      opacity: 0px;

      .service_head {
        width: auto;
        height: 16px;
        /* top: 1408px;
                left: 222px; */
        gap: 0px;
        opacity: 0px;

        .first {
          font-family: Manrope;
          font-size: 18px;
          font-weight: 800;
          line-height: 16px;
          text-align: left;
          color: #1b9075;
        }

        .second {
          font-family: Manrope;
          font-size: 18px;
          font-weight: 700;
          line-height: 16px;
          text-align: left;
          color: #13171b;
        }
      }

      .list_services {
        /* width: 233px; */
        /* height: 68px; */
        height: auto;
        top: 1438px;
        left: 222px;
        gap: 10px;
        opacity: 0px;
        display: flex;
        flex-direction: row;
        gap: 1rem;

        ol {
          display: flex;
          flex-direction: column;
          gap: 10px;
          gap: 1rem;
        }

        ol li {
          display: flex;
          align-items: center;
          /* width: 88px; */
          height: 18px;
          /* top: 1488px;
                    left: 222px; */
          gap: 10px;
          opacity: 0px;

          font-family: Manrope;
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          text-align: left;
          color: #696782;
        }

        ul {
          display: flex;
          flex-direction: column;
          gap: 10px;
          gap: 1rem;
        }

        ul li {
          display: flex;
          align-items: center;
          /* width: 88px; */
          height: 18px;
          /* top: 1488px;
                    left: 222px; */
          gap: 10px;
          opacity: 0px;

          font-family: Manrope;
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          text-align: left;
          color: #696782;
        }

        ol li {
          position: relative;
          padding-left: 20px;
          height: auto;
        }

        ol li::before {
          content: "";
          position: absolute;
          left: 0px;
          top: 50%;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: #1b9075;
          opacity: 1;
          transform: translateY(-50%);
        }

        ul li {
          position: relative;
          padding-left: 20px;
          height: auto;
        }

        ul li::before {
          content: "";
          position: absolute;
          left: 0px;
          top: 50%;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: #1b9075;
          opacity: 1;
          transform: translateY(-50%);
        }
      }
    }

    .service_button {
      width: 100%;
      height: 56px;
      /* top: 1526px;
            left: 214px; */
      padding: 20px;
      gap: 10px;
      border-radius: 10px;
      opacity: 0px;
      background: #1b9075;

      font-family: Manrope;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #fff;
    }
  }

  .seeall_button {
    width: 106px;
    height: 56px;
    top: 1628px;
    left: 667px;
    /* padding: 20px; */
    gap: 10px;
    border-radius: 10px;
    opacity: 0px;
    background: #ffffff;
    border: 1px solid #dce0e4;
  }
}

.about_us {
  /* display: flex; */
  flex-direction: row;
  justify-content: space-evenly;

  .about_left_section {
    /* width: 596px; */
    width: auto;
    height: 607.78px;
    /* height: auto; */
    top: 1744px;
    left: 117px;
    gap: 0px;
    opacity: 0px;
  }

  .about_right_section {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: auto;
    height: 607.78px;
    /* top: 1744px;
        left: 117px; */
    gap: 11rem;
    opacity: 0px;

    .about_head {
      /* width: 481px; */
      height: 56px;
      /* top: 1780px;
            left: 760px; */
      gap: 0px;
      opacity: 0px;

      .head {
        font-family: Manrope;
        font-size: 42px;
        font-weight: 700;
        line-height: 56px;
        letter-spacing: -0.0025em;
        text-align: left;
        color: #22263f;

        span {
          font-family: Manrope;
          font-size: 42px;
          font-weight: 800;
          line-height: 56px;
          letter-spacing: -0.0025em;
          text-align: left;
          color: #1b9075;
        }
      }

      .description {
        /* width: 500px; */
        height: 144px;
        /* top: 1840px;
                left: 760px; */
        gap: 0px;
        opacity: 0px;
        font-family: Manrope;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        color: #545454;
      }
    }

    .about_body {
      width: 324px;
      height: 40px;
      /* top: 2005px;
            left: 761px; */

      div {

        /* width: 324px;
                height: 40px; */
        span {
          width: 262px;
          height: 24px;
          /* top: 2012px;
                    left: 823px; */
          gap: 0px;
          opacity: 0px;
          font-family: Manrope;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          text-align: left;
          color: #22263f;
        }
      }
    }

    .about_footer {
      .footer_btn {
        width: 153px;
        height: 56px;
        /* top: 2221px;
                left: 761px; */
        /* padding: 20px; */
        gap: 10px;
        border-radius: 10px;
        opacity: 0px;
        background: #1b9075;
      }
    }
  }
}

/* download section */

.download_section {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 2;
  /* padding: 1rem; */
  padding-top: 1rem;

  /* width: 1480.79px; */
  /* min-height: 616px; */
  /* top: 52px; */
  /* left: 0.4px; */
  gap: 0px;
  /* border: 1px 0px 0px 0px; */
  opacity: 0px;

  .download_app_section {
    width: 100%;
    height: 495px;
    top: 2352px;
    gap: 0px;
    opacity: 0px;

    display: flex;
    flex-direction: column;

    .top_content {
      /* display: flex; */
      flex-direction: row;

      .left_section {
        margin-top: 6rem;
        width: 100%;
        height: auto;

        h2 {
          width: 100%;
          height: auto;
          /* top: 2448px;
                    left: 150px; */
          gap: 0px;
          opacity: 0px;
          font-family: Manrope;
          font-size: 42px;
          font-weight: 700;
          line-height: 68px;
          text-align: left;
          color: #000000;

          span {
            font-family: Manrope;
            font-size: 42px;
            font-weight: 800;
            line-height: 68px;
            text-align: left;
            color: #ff5555;
          }
        }

        div {
          width: 449.66px;
          height: 73px;
          /* top: 2625px;
                    left: 145px; */
          padding: 0px;
          gap: 0px;
          opacity: 0px;
        }
      }

      .right_section {
        width: auto;
        height: auto;
        top: 2426.12px;
        left: 492px;
        gap: 0px;
        opacity: 0px;
        /* margin-top: -17rem; */
        /* angle: 21.39 deg; */
      }
    }

    .footer_content {
      width: 100%;
      /* width: 1280px; */
      /* width: fit-content; */
      height: auto;
      /* top: 2794px;
            left: 150px; */
      gap: 1rem;
      border-radius: 63px;
      padding: 10px;
      opacity: 0px;
      background-color: #fff;
      box-shadow: 0px 2px 40px 0px #00000029;

      position: relative;
      top: -45%;
      /* top: 0%; */
      left: 0%;
      display: flex;
      flex-direction: row;
      /* justify-content: space-between; */

      .content {
        width: auto;
        height: 81px;
        /* top: 2808px;
                left: 290px; */
        gap: 0px;
        opacity: 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h6 {
          font-family: Manrope;
          font-size: 24px;
          font-weight: 800;
          line-height: 68px;
          text-align: left;
          color: #1b9075;
        }

        div {
          font-family: Manrope;
          font-size: 18px;
          font-weight: 500;
          line-height: 22px;
          text-align: left;
          color: #474a4c;
        }
      }

      .footer_btn {
        width: 153px;
        height: 56px;
        /* top: 2829px;
                left: 1085px; */
        padding: 20px;
        gap: 10px;
        border-radius: 10px;
        opacity: 0px;
        background: #1b9075;

        font-family: Manrope;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.02em;
        text-align: center;
        color: #ffffff;
        margin: auto 52px auto auto;
      }
    }
  }
}

/* testimonials section */

.testimonials_section {
  hr {
    border: 1px solid #1b9075;
  }

  .testimonial_head {
    width: auto;
    height: auto;
    /* width: 112px;
        height: 25px;
        top: 2991px;
        left: 664px; */
    gap: 0px;
    opacity: 0px;
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    line-height: 24.59px;
    text-align: center;
    color: #1b9075;
  }

  .testimonial_desc {
    width: auto;
    height: auto;
    /* width: 466px;
        height: 32px;
        top: 3026px;
        left: 487px; */
    gap: 0px;
    opacity: 0px;
    font-family: Manrope;
    font-size: 32px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.0025em;
    text-align: center;
    color: #22263f;
  }

  .testimonial_body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .testimonial_rank {
      width: 104.5px;
      height: 19px;
      /* top: 3102px;
            left: 668px; */
      gap: 0px;
      padding: 10px;
      opacity: 0px;

      border-top: 2px solid #1b9075;
    }

    .inverted_comma {
      position: relative;
      top: -3rem;
      left: -24rem;
    }

    .testimonial_text {
      width: 850px;
      height: auto;
      /* height: 296px; */
      /* top: 3126px;
            left: 295px; */
      gap: 0px;
      opacity: 0px;
      font-family: Manrope;
      font-size: 28px;
      font-weight: 600;
      line-height: 38.25px;
      text-align: center;
      color: #22263f;

      position: relative;
      top: -6rem;
      left: 1.5rem;
    }

    .testimonial_user_section {
      margin-top: -6rem;

      .active_testimonial {
        width: 122px;
        height: 122px;
        /* top: 3378px;
                left: 659px; */
        gap: 0px;
        opacity: 0px;

        box-shadow: 0px 2px 22px 0px #00000040;
      }

      .testimonial_user_name {
        width: 99px;
        height: 25px;
        /* top: 3513px;
                left: 671px; */
        gap: 0px;
        opacity: 0px;
        font-family: Manrope;
        font-size: 18px;
        font-weight: 700;
        line-height: 24.59px;
        text-align: center;
        color: #000000;
      }

      .btn_next {
        width: 36px;
        height: 36px;
        /* top: 3422px;
                left: 1216px; */
        gap: 0px;
        opacity: 0px;
        background-color: #1b9075;
        border-radius: 50%;
        padding: 0rem 0.8rem;
      }

      .btn_previous {
        width: 36px;
        height: 36px;
        /* top: 3422px;
                left: 1216px; */
        gap: 0px;
        opacity: 0px;
        background-color: #1b9075;
        border-radius: 50%;
        padding: 0rem 0.8rem;
      }
    }
  }
}

/* service expert section */
.service_expert {
  position: relative;
  /* background-image: url("../../assets/home/carousel.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat; */
  z-index: 2;
  /* padding-top: 1rem; */
  height: 100%;
  min-height: auto;
  gap: 0px;

  .service_expert_section {
    .left_section {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .top {
        width: 100%;
        height: auto;
        /* width: 584px; */
        /* height: 434px;
                top: 3618px;
                left: 149px; */
        gap: 0px;
        /* border: 1px 0px 0px 0px; */
        opacity: 0px;
        /* border: 1px solid #FFFFFF26; */

        display: flex;
        flex-direction: column;
        gap: 1rem;

        .top_head {
          width: 100%;
          height: auto;
          /* width: 372px;
                    height: 44px; */
          /* top: 3618px;
                    left: 149px;
                    gap: 0px;
                    opacity: 0px; */

          font-family: Manrope;
          font-size: 32px;
          font-weight: 700;
          line-height: 43.71px;
          text-align: left;

          span {
            font-family: Manrope;
            font-size: 32px;
            font-weight: 800;
            line-height: 43.71px;
            /* text-align: center; */
            color: #1b9075;
          }
        }

        .section_text1 {
          display: flex;
          gap: 1rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #1b9075;

          img {
            background-color: #fff;
            padding: 1rem;
            width: 66px;
            height: 66px;
            /* top: 3705px;
                        left: 150px; */
            gap: 0px;
            border-radius: 14px;
            opacity: 0px;
          }

          div {
            .service_exp_head {
              width: 260px;
              height: 33px;
              /* top: 3703px;
                            left: 231px; */
              gap: 0px;
              opacity: 0px;
              font-family: Manrope;
              font-size: 24px;
              font-weight: 600;
              line-height: 32.78px;
              text-align: left;
              color: #ffffff;
            }

            .service_exp_desc {
              width: 100%;
              /* width: 502px; */
              height: 50px;
              /* top: 3739px;
                            left: 231px; */
              gap: 0px;
              opacity: 0px;
              font-family: Manrope;
              font-size: 16px;
              font-weight: 400;
              line-height: 21.86px;
              text-align: left;
              color: #ffffff;
            }
          }
        }

        .section_text2 {
          display: flex;
          gap: 1rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #1b9075;

          img {
            background-color: #fff;
            padding: 1rem;
            width: 66px;
            height: 66px;
            /* top: 3705px;
                        left: 150px; */
            gap: 0px;
            border-radius: 14px;
            opacity: 0px;
          }

          div {
            .service_exp_head {
              width: 260px;
              height: 33px;
              /* top: 3703px;
                            left: 231px; */
              gap: 0px;
              opacity: 0px;
              font-family: Manrope;
              font-size: 24px;
              font-weight: 600;
              line-height: 32.78px;
              text-align: left;
              color: #ffffff;
            }

            .service_exp_desc {
              /* width: 502px; */
              width: 100%;
              height: 50px;
              /* top: 3739px;
                            left: 231px; */
              gap: 0px;
              opacity: 0px;
              font-family: Manrope;
              font-size: 16px;
              font-weight: 400;
              line-height: 21.86px;
              text-align: left;
              color: #ffffff;
            }
          }
        }

        .section_text3 {
          display: flex;
          gap: 1rem;
          padding-bottom: 1rem;

          img {
            background-color: #fff;
            padding: 1rem;
            width: 66px;
            height: 66px;
            /* top: 3705px;
                        left: 150px; */
            gap: 0px;
            border-radius: 14px;
            opacity: 0px;
          }

          div {
            .service_exp_head {
              width: 260px;
              height: 33px;
              /* top: 3703px;
                            left: 231px; */
              gap: 0px;
              opacity: 0px;
              font-family: Manrope;
              font-size: 24px;
              font-weight: 600;
              line-height: 32.78px;
              text-align: left;
              color: #ffffff;
            }

            .service_exp_desc {
              /* width: 502px; */
              width: 100%;
              height: 50px;
              /* top: 3739px;
                            left: 231px; */
              gap: 0px;
              opacity: 0px;
              font-family: Manrope;
              font-size: 16px;
              font-weight: 400;
              line-height: 21.86px;
              text-align: left;
              color: #ffffff;
            }
          }
        }
      }

      .bottom {
        .bottom_btn {
          width: 145px;
          height: 56px;
          /* top: 4081px;
                    left: 150px; */
          padding: 16px;
          gap: 10px;
          border-radius: 10px;
          opacity: 0px;
          background: #1b9075;
          color: #fff;
        }
      }
    }
  }
}

.service_expert::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: radial-gradient(104% 47.97% at 50% 52.03%,
      #082b23 0%,
      #10182f 100%);
  /* background: radial-gradient(104% 47.97% at 50% 52.03%, #1A9175 0%, #082B23 100%); */
  opacity: 0.95;
  pointer-events: none;
  height: 100%;
  min-height: auto;
}

/* blog section */
.blog_section {
  .blogs_head {
    /* width: 49px;
        height: 25px;
        top: 4235px;
        left: 696px;
        gap: 0px;
        opacity: 0px; */
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    line-height: 24.59px;
    text-align: left;
    color: #1b9075;
  }

  .blogs_desc {
    /* width: 466px;
        height: 32px;
        top: 4267px;
        left: 487px;
        gap: 0px;
        opacity: 0px; */
    font-family: Manrope;
    font-size: 32px;
    font-weight: 800;
    line-height: 32px;
    letter-spacing: -0.0025em;
    text-align: center;
    color: #22263f;
  }

  .blog_section_card {
    .blog_card {
      width: 100%;
      height: auto;
      /* width: 360px;
            height: 334px; */
      /* top: 4328px;
            left: 150px;
            gap: 0px; */
      border-radius: 17px;
      border: 1px;
      opacity: 0px;

      border: 1px solid #1b9075;
      box-shadow: 0px 2px 32px 0px #0000001a;

      img {
        width: 100%;
        height: auto;
        /* width: 324px;
                height: 201px;
                top: 4346px;
                left: 168px;
                gap: 0px; */
        border-radius: 8px;
        opacity: 0px;
      }

      div {
        width: 100%;
        /* width: 238px; */
        /* height: 57px; */
        /* top: 4583px;
                left: 168px;
                gap: 0px;
                opacity: 0px; */

        h3 {
          width: auto;
          height: 25px;
          /* top: 4583px;
                    left: 168px;
                    gap: 0px;
                    opacity: 0px; */
          font-family: Manrope;
          font-size: 18px;
          font-weight: 700;
          line-height: 24.59px;
          text-align: left;
          color: #000000;
        }

        div {
          width: auto;

          /* height: 22px;
                    top: 4618px;
                    left: 169px;
                    gap: 0px;
                    opacity: 0px; */
          img {
            width: 18.72px;
            height: 19px;
            /* top: 4619px;
                        left: 169px;
                        gap: 0px;
                        opacity: 0px; */
          }

          p {
            font-family: Manrope;
            font-size: 16px;
            font-weight: 400;
            line-height: 21.86px;
            text-align: left;
          }
        }
      }
    }
  }

  .blog_button {
    width: 106px;
    height: 56px;
    /* top: 4691px;
        left: 667px; */
    padding: 16px;
    gap: 10px;
    border-radius: 10px;
    opacity: 0px;
    background: #1b9075;
    color: #fff;
  }
}

/* footer css */

.footer_home {
  position: relative;
  overflow-x: hidden;
  /* background-image: url("../../assets/home/carousel.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat; */
  z-index: 2;

  .footer_bottom {
    .company_options {
      width: 100%;
      height: 100%;
      /* width: 298px; */
      /* height: 162px; */
      /* top: 4913px;
            left: 100px; */
      /* gap: 16px; */
      border-radius: 12px;
      opacity: 0px;

      .head {
        width: 114px;
        height: 30px;
        gap: 0px;
        opacity: 0px;
        font-family: Lexend;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        text-align: right;
        color: #efefef;
      }

      ul {
        display: flex;
        flex-direction: column;
        width: 298px;
        height: 116px;
        gap: 12px;
        opacity: 0px;

        li {
          width: 298px;
          height: 20px;
          gap: 0px;
          opacity: 0px;
          font-family: Lexend;
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          color: #c4c4c4;
        }
      }
    }

    .customer_options {
      width: 100%;
      height: 100%;
      /* width: 298px; */
      /* height: 162px; */
      /* top: 4913px;
            left: 100px; */
      /* gap: 16px; */
      border-radius: 12px;
      opacity: 0px;

      .head {
        width: 114px;
        height: 30px;
        gap: 0px;
        opacity: 0px;
        font-family: Lexend;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        text-align: right;
        color: #efefef;
      }

      ul {
        display: flex;
        flex-direction: column;
        width: 298px;
        height: 116px;
        gap: 12px;
        opacity: 0px;

        li {
          width: 298px;
          height: 20px;
          gap: 0px;
          opacity: 0px;
          font-family: Lexend;
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          color: #c4c4c4;
        }
      }
    }

    .partner_options {
      width: 100%;
      height: 100%;
      /* width: 298px; */
      /* height: 162px; */
      /* top: 4913px;
            left: 100px; */
      /* gap: 16px; */
      border-radius: 12px;
      opacity: 0px;

      .head {
        width: 114px;
        height: 30px;
        gap: 0px;
        opacity: 0px;
        font-family: Lexend;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        /* text-align: right; */
        color: #efefef;
      }

      ul {
        display: flex;
        flex-direction: column;
        width: 298px;
        height: 116px;
        gap: 12px;
        opacity: 0px;

        li {
          width: 298px;
          height: 20px;
          gap: 0px;
          opacity: 0px;
          font-family: Lexend;
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          color: #c4c4c4;
        }
      }
    }

    .social_options {
      width: 100%;
      height: 100%;
      /* width: 102px;
            height: 162px; */
      /* top: 4913px;
            left: 100px; */
      /* gap: 16px; */

      border-radius: 12px;
      opacity: 0px;

      .head {
        width: 114px;
        height: 30px;
        gap: 0px;
        opacity: 0px;
        font-family: Lexend;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        /* text-align: right; */
        color: #efefef;
      }

      ul {
        display: flex;
        flex-direction: column;
        width: 298px;
        height: 116px;
        gap: 12px;
        opacity: 0px;

        li {
          width: 298px;
          height: 20px;
          gap: 0px;
          opacity: 0px;
          font-family: Lexend;
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          color: #c4c4c4;
        }
      }
    }
  }
}

.footer_home::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: radial-gradient(104% 47.97% at 50% 52.03%,
      #082b23 0%,
      #10182f 100%);
  /* background: radial-gradient(104% 47.97% at 50% 52.03%, #1A9175 0%, #082B23 100%); */
  /* opacity: 0.95; */
  pointer-events: none;
  height: 100%;
  min-height: auto;
}

.hero-image {
  /* background-image: url(''); */
  background-size: cover;
  background-position: center;
}

.testimonial {
  max-width: 600px;
  margin: auto;
}

.offer-card img {
  transition: transform 0.3s ease-in-out;
}

.offer-card:hover img {
  transform: scale(1.05);
}

.offer-card .discount-badge {
  top: 0;
  left: 0;
  margin-top: 16px;
  margin-left: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
}

/* media queries */
@media (min-width: 768px) {
  .services_section .service_section_body .card .service_button {
    display: inline-block;
    /* position: absolute; */
    left: 0;
    right: 0;
    bottom: 20px;
    /* width: calc(100% - 3rem); */
    margin: auto;
    margin-top: 20px;
  }
}

@media (max-width: 499px) {
  .carousel .carousel_content {
    display: grid;
  }

  .carousel::before {
    min-height: 100%;
  }

  .carousel .carousel_content .right_content {
    top: 0px;
  }

  .carousel .carousel_content .left_content {
    height: auto !important;
  }

  .carousel .carousel_content .left_content .carousel_input .custom_service_btn {
    padding-left: 0.75rem;
  }

  .carousel .carousel_content .left_content {
    .carousel_input {
      width: 334px;
    }
  }

  .carousel .carousel_button {
    bottom: 6rem;
  }

  .services_section {
    padding: 0.25rem;
  }

  .services_section .seeall_button {
    margin-bottom: 1rem;
  }

  .about_us {
    .about_left_section {
      height: auto;
    }
  }

  .about_us .about_right_section {
    .about_body {
      width: auto;
      margin-top: 6rem;
    }
  }

  .about_us .about_right_section .about_body div {
    justify-content: stretch;
  }

  .download_section .download_app_section .top_content .left_section div {
    width: auto;
    height: auto;
  }

  .download_section {
    min-height: 668px;
  }

  .download_section .download_app_section {
    height: 100%;
  }

  .download_section .download_app_section .footer_content .content {
    height: auto;
  }

  .download_section .download_app_section .footer_content .content h6 {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  .download_section .download_app_section .footer_content .content div {
    font-size: 13px;
    font-weight: 500;
  }

  .download_section .download_app_section .footer_content .footer_btn {
    width: 210px;
    padding: 5px;
    font-size: 11px;
    font-weight: 600;
  }

  .testimonials_section .testimonial_body .testimonial_text {
    width: auto;
    font-size: 20px;
    left: 0rem;
  }

  .testimonials_section .testimonial_body .testimonial_user_section .active_testimonial {
    width: 75px;
    height: 75px;
  }

  .testimonials_section .testimonial_body .testimonial_user_section .not_activetestimonials {
    width: 60px;
    height: 45px;
  }

  .testimonials_section .testimonial_body .inverted_comma {
    width: 75px;
    height: 150px;
    position: relative;
    top: -3rem;
    left: -9rem;
  }

  .footer_home .footer_bottom .partner_options ul {
    height: auto;
  }
}

@media (min-width: 500px) and (max-width: 640px) {
  /* Custom styles for mobile screens */

  .carousel .carousel_content {
    display: grid;
  }

  .carousel::before {
    min-height: 100%;
  }

  .carousel .carousel_content .right_content {
    top: 0px;
  }

  .carousel .carousel_content .left_content {
    height: auto !important;
  }

  .carousel .carousel_content .left_content .carousel_input .custom_service_btn {
    padding-left: 0.75rem;
  }

  .carousel .carousel_content .left_content {
    .carousel_input {
      width: 334px;
    }
  }

  .carousel .carousel_button {
    bottom: 6rem;
  }

  .about_right_section {
    .about_body {
      margin-top: 2rem;
    }
  }

  .about_left_section {
    height: auto !important;
  }

  .download_section {
    min-height: 668px;
  }

  .download_section .download_app_section {
    height: 100%;
  }

  .download_section .download_app_section .footer_content .content h6 {
    font-size: 20px;
    font-weight: 700;
  }

  .download_section .download_app_section .footer_content .content div {
    font-size: 15px;
    font-weight: 500;
  }

  .download_section .download_app_section .footer_content .footer_btn {
    width: 180px;
    padding: 10px;
    font-size: 13px;
    font-weight: 600;
  }

  .testimonials_section .testimonial_body .testimonial_text {
    width: auto;
    font-size: 20px;
    left: 0rem;
  }

  .testimonials_section .testimonial_body .testimonial_user_section .active_testimonial {
    width: 75px;
    height: 75px;
  }

  .testimonials_section .testimonial_body .testimonial_user_section .not_activetestimonials {
    width: 60px;
    height: 45px;
  }

  .testimonials_section .testimonial_body .inverted_comma {
    width: 75px;
    height: 150px;
    position: relative;
    top: -3rem;
    left: -11rem;
  }

  .testimonial p {
    font-size: 14px;
  }

  .hero-image {
    background-position: top;
  }

  /* Example of modifying Tailwind utilities */
  .md\\\\:hidden {
    display: block;
  }

  .offer-card p {
    font-size: 14px;
  }

  .footer_home .footer_bottom .partner_options ul {
    height: auto;
  }
}

@media (min-width: 641px) and (max-width: 1024px) {
  /* Custom styles for tablet screens */

  .carousel .carousel_content .left_content {
    height: auto !important;
  }

  .carousel .carousel_content .left_content .carousel_input .custom_service_btn {
    padding-left: 1rem;
  }

  .carousel .carousel_content .left_content {
    width: 50%;
    .carousel_input {
      width: 334px;
    }
  }

  .about_right_section {
    justify-content: space-between;

    .about_body {
      margin-top: 11rem;
    }
  }

  .download_section .download_app_section {
    height: 100%;
  }

  .download_section .download_app_section .footer_content .content h6 {
    font-size: 22px;
    font-weight: 700;
  }

  .download_section .download_app_section .footer_content .content div {
    font-size: 16px;
    font-weight: 500;
  }

  .download_section .download_app_section .footer_content .footer_btn {
    width: 160px;
    padding: 12px;
    font-size: 13px;
    font-weight: 600;
  }

  .testimonials_section .testimonial_body .testimonial_text {
    width: auto;
    font-size: 24px;
    left: 0rem;
  }

  .testimonials_section .testimonial_body .testimonial_user_section .active_testimonial {
    width: 80px;
    height: 80px;
  }

  .testimonials_section .testimonial_body .testimonial_user_section .not_activetestimonials {
    width: 70px;
    height: 50px;
  }

  .testimonials_section .testimonial_body .inverted_comma {
    width: 100px;
    height: 200px;
    position: relative;
    top: -3rem;
    left: -16rem;
  }

  .testimonial p {
    font-size: 16px;
  }

  .offer-card p {
    font-size: 16px;
  }
}

@media (min-width: 1025px) and (max-width: 1368px) {

  /* Custom styles for desktop screens */
  .carousel .carousel_content .left_content {
    height: auto !important;
  }

  .about_right_section {
    .about_body {
      margin-top: 6rem;
    }
  }

  .download_section .download_app_section {
    height: 100%;
  }
}

@media (min-width: 1200px) {
  .download_section .download_app_section .footer_content {
    top: -54%;
  }

  .testimonials_section {
    margin-top: 4rem;
  }
}

@media (max-width: 768px) {
  .about_right_section .about_body {
    margin-top: 0;
  }

  .about_us .about_right_section {
    height: auto;
    row-gap: 11rem !important;
  }

  .about_us {
    display: flex;
    flex-direction: column;
    gap: 7rem;
  }

  .about_us .about_head .head {
    margin-bottom: 10px;
  }
}

@media (max-width: 640px) {
  .carousel .carousel_content .right_content {
    height: auto;
    top: 50px;
  }

  .carousel .carousel_content .left_content {
    width: 100%;
  }
}

@media (max-width: 575px) {
  .about_us {
    gap: 0rem;
  }

  .about_us .about_right_section {
    row-gap: 13rem !important;
  }

  .offer_head h1,
  .service_section_head h1,
  .about_us .about_head .head,
  .about_us .about_head .head span,
  .left_section h2,
  .left_section h2 span,
  .blog_section h1,
  .testimonials_section h2 {
    font-size: 25px !important;
    line-height: normal !important;
    text-align: center !important;
  }

  .left_section span.testimonial_head {
    text-align: center;
    display: block;
  }

  .about_us .about_right_section .about_head .description {
    text-align: justify;
  }

  .offers_section .offers_body_content .card .left_content .offer_text {
    font-size: 18px;
    line-height: normal;
  }

  .download_app_section .footer_content {
    flex-direction: column !important;
    align-items: center;
  }

  .download_app_section .footer_content>img {
    width: 70px;
  }

  .footer_content .content h6,
  .footer_content .content>div {
    text-align: center !important;
  }

  .service_expert_section .left_section .top img {
    padding: 5px !important;
    width: 50px !important;
    height: 50px !important;
  }

  .service_expert_section .left_section .top>div {
    padding-bottom: 2.5rem !important;
  }

  .carousel .carousel_content .left_content .left_content_text {
    font-size: 25px;
    line-height: 1.6 !important;
  }

  .download_section .download_app_section .top_content .left_section {
    margin-top: 2rem;
  }

  .download_section {
    padding-bottom: 50px;
  }

  .header_company_logo {
    width: 220px;
  }

  .offers_section .offers_body_content .card .left_content .offer_percent span {
    width: 50px;
    height: 50px;
    font-size: 16px;
  }

}

#services{
  padding-left: 0 !important;padding-right: 0 !important;
}

/* 
@media (min-width: 320px) {
  .container{
    max-width: 100%;
  }

} */`, "",{"version":3,"sources":["webpack://./src/styles/home/home.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,yDAAuD;EACvD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,mBAAmB;EACnB,iBAAiB;;EAEjB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,6BAA6B;EAC7B,YAAY;;EAEZ;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,UAAU;IACV,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,YAAY;;IAEZ,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,0DAA0D;EAC5D;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;mBAEiB;EACjB,sFAAsF;EACtF,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;;EAExB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY;;IAEZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;;IAEd;MACE,qBAAqB;MACrB,qBAAqB;MACrB;2BACqB;MACrB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY;;IAEZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ;cACU;IACV,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;;IAEzB;MACE,mBAAmB;MACnB,WAAW;MACX,oBAAoB;MACpB,uBAAuB;MACvB,6BAA6B;MAC7B,YAAY;;MAEZ,aAAa;MACb,mBAAmB;;MAEnB,kBAAkB;MAClB,YAAY;MACZ;0BACoB;MACpB,QAAQ;MACR,YAAY;;MAEZ;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;MACpB;;MAEA;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;MACpB;IACF;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,oBAAoB;MACpB,uBAAuB;MACvB,6BAA6B;MAC7B,YAAY;;MAEZ,aAAa;MACb,mBAAmB;;MAEnB,kBAAkB;MAClB,YAAY;MACZ;0BACoB;MACpB,QAAQ;MACR,YAAY;;MAEZ;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;MAClB;IACF;;IAEA;MACE,qBAAqB;MACrB,aAAa;IACf;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,SAAS;IACX;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,QAAQ;MACR,2BAA2B;MAC3B,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,2BAA2B;MAC3B,cAAc;IAChB;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qBAAqB;;EAErB;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB;MAClB,cAAc;IAChB;EACF;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ;sBACkB;IAClB,YAAY;IACZ,yBAAyB;;IAEzB;MACE,aAAa;MACb,sBAAsB;MACtB,oCAAoC;MACpC,qBAAqB;MACrB,SAAS;;MAET;QACE,aAAa;;QAEb;UACE,WAAW;UACX,YAAY;UACZ,yBAAyB;UACzB,YAAY;UACZ,kBAAkB;UAClB,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,eAAe;UACf,gBAAgB;UAChB,oBAAoB;QACtB;;QAEA;UACE,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;;MAEA;QACE,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,WAAW;QACX,QAAQ;QACR,YAAY;;QAEZ,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;MAChB;;MAEA;QACE,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;;QAEhB,cAAc;MAChB;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB;;;2BAGqB;IACvB;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB;kBACgB;EAChB,QAAQ;EACR,YAAY;EACZ,mBAAmB;;EAEnB;IACE;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB;MAClB,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC;sBACkB;IAClB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;;IAElB;MACE;yBACmB;MACnB,WAAW;MACX,WAAW;MACX,QAAQ;MACR,YAAY;;MAEZ,aAAa;MACb,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ;0BACoB;MACpB,QAAQ;MACR,YAAY;;MAEZ;QACE,WAAW;QACX,YAAY;QACZ;8BACsB;QACtB,QAAQ;QACR,YAAY;;QAEZ;UACE,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;;MAEA;QACE,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,WAAW;QACX,SAAS;QACT,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,SAAS;;QAET;UACE,aAAa;UACb,sBAAsB;UACtB,SAAS;UACT,SAAS;QACX;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,iBAAiB;UACjB,YAAY;UACZ;kCACwB;UACxB,SAAS;UACT,YAAY;;UAEZ,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,SAAS;UACT,SAAS;QACX;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,iBAAiB;UACjB,YAAY;UACZ;kCACwB;UACxB,SAAS;UACT,YAAY;;UAEZ,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,kBAAkB;UAClB,kBAAkB;UAClB,YAAY;QACd;;QAEA;UACE,WAAW;UACX,kBAAkB;UAClB,SAAS;UACT,QAAQ;UACR,UAAU;UACV,WAAW;UACX,kBAAkB;UAClB,yBAAyB;UACzB,UAAU;UACV,2BAA2B;QAC7B;;QAEA;UACE,kBAAkB;UAClB,kBAAkB;UAClB,YAAY;QACd;;QAEA;UACE,WAAW;UACX,kBAAkB;UAClB,SAAS;UACT,QAAQ;UACR,UAAU;UACV,WAAW;UACX,kBAAkB;UAClB,yBAAyB;UACzB,UAAU;UACV,2BAA2B;QAC7B;MACF;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ;0BACoB;MACpB,aAAa;MACb,SAAS;MACT,mBAAmB;MACnB,YAAY;MACZ,mBAAmB;;MAEnB,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;MAClB,WAAW;IACb;EACF;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;;EAE7B;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,WAAW;IACX,gBAAgB;IAChB;sBACkB;IAClB,UAAU;IACV,YAAY;;IAEZ;MACE,kBAAkB;MAClB,YAAY;MACZ;0BACoB;MACpB,QAAQ;MACR,YAAY;;MAEZ;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;;QAEd;UACE,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,yBAAyB;UACzB,gBAAgB;UAChB,cAAc;QAChB;MACF;;MAEA;QACE,kBAAkB;QAClB,aAAa;QACb;8BACsB;QACtB,QAAQ;QACR,YAAY;QACZ,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;MAChB;IACF;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ;0BACoB;;MAEpB;;QAEE;+BACuB;QACvB;UACE,YAAY;UACZ,YAAY;UACZ;kCACwB;UACxB,QAAQ;UACR,YAAY;UACZ,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;IACF;;IAEA;MACE;QACE,YAAY;QACZ,YAAY;QACZ;8BACsB;QACtB,mBAAmB;QACnB,SAAS;QACT,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,yDAAkE;EAClE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,mBAAmB;EACnB,iBAAiB;;EAEjB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,6BAA6B;EAC7B,YAAY;;EAEZ;IACE,WAAW;IACX,aAAa;IACb,WAAW;IACX,QAAQ;IACR,YAAY;;IAEZ,aAAa;IACb,sBAAsB;;IAEtB;MACE,mBAAmB;MACnB,mBAAmB;;MAEnB;QACE,gBAAgB;QAChB,WAAW;QACX,YAAY;;QAEZ;UACE,WAAW;UACX,YAAY;UACZ;kCACwB;UACxB,QAAQ;UACR,YAAY;UACZ,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;;UAEd;YACE,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,cAAc;UAChB;QACF;;QAEA;UACE,eAAe;UACf,YAAY;UACZ;kCACwB;UACxB,YAAY;UACZ,QAAQ;UACR,YAAY;QACd;MACF;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,cAAc;QACd,WAAW;QACX,QAAQ;QACR,YAAY;QACZ,wBAAwB;QACxB,sBAAsB;MACxB;IACF;;IAEA;MACE,WAAW;MACX,mBAAmB;MACnB,wBAAwB;MACxB,YAAY;MACZ;0BACoB;MACpB,SAAS;MACT,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,sCAAsC;;MAEtC,kBAAkB;MAClB,SAAS;MACT,aAAa;MACb,QAAQ;MACR,aAAa;MACb,mBAAmB;MACnB,oCAAoC;;MAEpC;QACE,WAAW;QACX,YAAY;QACZ;8BACsB;QACtB,QAAQ;QACR,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,uBAAuB;;QAEvB;UACE,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;;MAEA;QACE,YAAY;QACZ,YAAY;QACZ;+BACuB;QACvB,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;;QAEnB,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;QAClB,cAAc;QACd,2BAA2B;MAC7B;IACF;EACF;AACF;;AAEA,yBAAyB;;AAEzB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ;;;sBAGkB;IAClB,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ;;;sBAGkB;IAClB,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE,cAAc;MACd,YAAY;MACZ;0BACoB;MACpB,QAAQ;MACR,aAAa;MACb,YAAY;;MAEZ,6BAA6B;IAC/B;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,YAAY;IACd;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB;0BACoB;MACpB,QAAQ;MACR,YAAY;MACZ,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,kBAAkB;MAClB,cAAc;;MAEd,kBAAkB;MAClB,UAAU;MACV,YAAY;IACd;;IAEA;MACE,iBAAiB;;MAEjB;QACE,YAAY;QACZ,aAAa;QACb;8BACsB;QACtB,QAAQ;QACR,YAAY;;QAEZ,sCAAsC;MACxC;;MAEA;QACE,WAAW;QACX,YAAY;QACZ;8BACsB;QACtB,QAAQ;QACR,YAAY;QACZ,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,cAAc;MAChB;;MAEA;QACE,WAAW;QACX,YAAY;QACZ;+BACuB;QACvB,QAAQ;QACR,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,oBAAoB;MACtB;;MAEA;QACE,WAAW;QACX,YAAY;QACZ;+BACuB;QACvB,QAAQ;QACR,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,oBAAoB;MACtB;IACF;EACF;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB;;;mCAGiC;EACjC,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;;EAER;IACE;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;;MAET;QACE,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB;;8BAEsB;QACtB,QAAQ;QACR,6BAA6B;QAC7B,YAAY;QACZ,iCAAiC;;QAEjC,aAAa;QACb,sBAAsB;QACtB,SAAS;;QAET;UACE,WAAW;UACX,YAAY;UACZ;mCACyB;UACzB;;;mCAGyB;;UAEzB,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,oBAAoB;UACpB,gBAAgB;;UAEhB;YACE,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,oBAAoB;YACpB,wBAAwB;YACxB,cAAc;UAChB;QACF;;QAEA;UACE,aAAa;UACb,SAAS;UACT,oBAAoB;UACpB,gCAAgC;;UAEhC;YACE,sBAAsB;YACtB,aAAa;YACb,WAAW;YACX,YAAY;YACZ;sCAC0B;YAC1B,QAAQ;YACR,mBAAmB;YACnB,YAAY;UACd;;UAEA;YACE;cACE,YAAY;cACZ,YAAY;cACZ;0CAC4B;cAC5B,QAAQ;cACR,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc;YAChB;;YAEA;cACE,WAAW;cACX,kBAAkB;cAClB,YAAY;cACZ;0CAC4B;cAC5B,QAAQ;cACR,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc;YAChB;UACF;QACF;;QAEA;UACE,aAAa;UACb,SAAS;UACT,oBAAoB;UACpB,gCAAgC;;UAEhC;YACE,sBAAsB;YACtB,aAAa;YACb,WAAW;YACX,YAAY;YACZ;sCAC0B;YAC1B,QAAQ;YACR,mBAAmB;YACnB,YAAY;UACd;;UAEA;YACE;cACE,YAAY;cACZ,YAAY;cACZ;0CAC4B;cAC5B,QAAQ;cACR,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc;YAChB;;YAEA;cACE,kBAAkB;cAClB,WAAW;cACX,YAAY;cACZ;0CAC4B;cAC5B,QAAQ;cACR,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc;YAChB;UACF;QACF;;QAEA;UACE,aAAa;UACb,SAAS;UACT,oBAAoB;;UAEpB;YACE,sBAAsB;YACtB,aAAa;YACb,WAAW;YACX,YAAY;YACZ;sCAC0B;YAC1B,QAAQ;YACR,mBAAmB;YACnB,YAAY;UACd;;UAEA;YACE;cACE,YAAY;cACZ,YAAY;cACZ;0CAC4B;cAC5B,QAAQ;cACR,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc;YAChB;;YAEA;cACE,kBAAkB;cAClB,WAAW;cACX,YAAY;cACZ;0CAC4B;cAC5B,QAAQ;cACR,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc;YAChB;UACF;QACF;MACF;;MAEA;QACE;UACE,YAAY;UACZ,YAAY;UACZ;kCACwB;UACxB,aAAa;UACb,SAAS;UACT,mBAAmB;UACnB,YAAY;UACZ,mBAAmB;UACnB,WAAW;QACb;MACF;IACF;EACF;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;mBAEiB;EACjB,sFAAsF;EACtF,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE;;;;;uBAKmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE;;;;;uBAKmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ;4BACsB;MACtB;;uBAEiB;MACjB,mBAAmB;MACnB,WAAW;MACX,YAAY;;MAEZ,yBAAyB;MACzB,sCAAsC;;MAEtC;QACE,WAAW;QACX,YAAY;QACZ;;;;2BAImB;QACnB,kBAAkB;QAClB,YAAY;MACd;;MAEA;QACE,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB;;;+BAGuB;;QAEvB;UACE,WAAW;UACX,YAAY;UACZ;;;mCAGyB;UACzB,oBAAoB;UACpB,eAAe;UACf,gBAAgB;UAChB,oBAAoB;UACpB,gBAAgB;UAChB,cAAc;QAChB;;QAEA;UACE,WAAW;;UAEX;;;;mCAIyB;UACzB;YACE,cAAc;YACd,YAAY;YACZ;;;uCAG2B;UAC7B;;UAEA;YACE,oBAAoB;YACpB,eAAe;YACf,gBAAgB;YAChB,oBAAoB;YACpB,gBAAgB;UAClB;QACF;MACF;IACF;EACF;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ;sBACkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA,eAAe;;AAEf;EACE,kBAAkB;EAClB,kBAAkB;EAClB;;;mCAGiC;EACjC,UAAU;;EAEV;IACE;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB;0BACoB;MACpB,eAAe;MACf,mBAAmB;MACnB,YAAY;;MAEZ;QACE,YAAY;QACZ,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,cAAc;MAChB;;MAEA;QACE,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,SAAS;QACT,YAAY;;QAEZ;UACE,YAAY;UACZ,YAAY;UACZ,QAAQ;UACR,YAAY;UACZ,mBAAmB;UACnB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB;0BACoB;MACpB,eAAe;MACf,mBAAmB;MACnB,YAAY;;MAEZ;QACE,YAAY;QACZ,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,cAAc;MAChB;;MAEA;QACE,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,SAAS;QACT,YAAY;;QAEZ;UACE,YAAY;UACZ,YAAY;UACZ,QAAQ;UACR,YAAY;UACZ,mBAAmB;UACnB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB;0BACoB;MACpB,eAAe;MACf,mBAAmB;MACnB,YAAY;;MAEZ;QACE,YAAY;QACZ,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,cAAc;MAChB;;MAEA;QACE,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,SAAS;QACT,YAAY;;QAEZ;UACE,YAAY;UACZ,YAAY;UACZ,QAAQ;UACR,YAAY;UACZ,mBAAmB;UACnB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ;4BACsB;MACtB;0BACoB;MACpB,eAAe;;MAEf,mBAAmB;MACnB,YAAY;;MAEZ;QACE,YAAY;QACZ,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,cAAc;MAChB;;MAEA;QACE,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,SAAS;QACT,YAAY;;QAEZ;UACE,YAAY;UACZ,YAAY;UACZ,QAAQ;UACR,YAAY;UACZ,mBAAmB;UACnB,eAAe;UACf,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;QAChB;MACF;IACF;EACF;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;mBAEiB;EACjB,sFAAsF;EACtF,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE;IACE,qBAAqB;IACrB,wBAAwB;IACxB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,WAAW;MACX,gBAAgB;IAClB;EACF;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,qCAAqC;;EAErC;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,YAAY;IACd;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,4CAA4C;EAC5C;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,qCAAqC;;EAErC;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IAIV;MACE,YAAY;IACd;EALF;;EAQA;IACE,8BAA8B;;IAE9B;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,sCAAsC;EACtC;IACE,uBAAuB;EACzB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IAIZ,SAAS;EAHX;;EAMA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;;;;;;IAQE,0BAA0B;IAC1B,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;AAEF;;AAEA;EACE,0BAA0B,CAAC,2BAA2B;AACxD;;AAEA;;;;;;GAMG","sourcesContent":["/* carousel section */\n\n.carousel {\n  position: relative;\n  background-image: url(\"../../assets/home/carousel.svg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  z-index: 2;\n  /* padding: 1rem; */\n  padding-top: 1rem;\n\n  /* width: 1480.79px; */\n  min-height: 616px;\n  /* top: 52px; */\n  /* left: 0.4px; */\n  gap: 0px;\n  /* border: 1px 0px 0px 0px; */\n  opacity: 0px;\n\n  .carousel_button {\n    bottom: -3rem;\n    left: 50%;\n  }\n\n  .dot {\n    width: 8px;\n    height: 8px;\n    gap: 0px;\n    border-radius: 10px;\n    opacity: 0px;\n\n    background-color: #ccd2d6;\n    margin: 0 4px;\n    cursor: pointer;\n    transition: background-color 0.3s, width 0.3s, height 0.3s;\n  }\n\n  .dot.active {\n    background-color: #1b9075;\n    width: 26px;\n    height: 8px;\n  }\n}\n\n.carousel::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: radial-gradient(104% 47.97% at 50% 52.03%,\n      #082b23 0%,\n      #10182f 100%);\n  /* background: radial-gradient(104% 47.97% at 50% 52.03%, #1A9175 0%, #082B23 100%); */\n  /* opacity: 0.95; */\n  pointer-events: none;\n  height: auto;\n  min-height: 616px;\n}\n\n.carousel .carousel_content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\n\n.carousel .carousel_content .left_content {\n  /* width: 500px; */\n  display: flex;\n  flex-direction: column;\n  height: 310px;\n  top: 221px;\n  left: 150px;\n  /* gap: 10px; */\n  border-radius: 6px;\n  opacity: 0px;\n  width: calc(50% - 100px);\n\n  .left_content_text {\n    /* width: 493px; */\n    /* height: 168px; */\n    height: auto;\n    top: 221px;\n    left: 150px;\n    gap: 0px;\n    opacity: 0px;\n\n    font-family: Manrope;\n    font-size: 42px;\n    font-weight: 800;\n    line-height: 56px;\n    letter-spacing: -0.0025em;\n    text-align: left;\n    color: #2fc7a4;\n\n    .sup_image {\n      vertical-align: super;\n      display: inline-block;\n      /* width: 1rem;\n            height: 1rem; */\n      margin: 0;\n    }\n\n    span {\n      color: #fff;\n    }\n  }\n\n  .left_content_subtext {\n    /* width: 500px; */\n    /* height: 56px; */\n    height: auto;\n    top: 402px;\n    left: 150px;\n    gap: 0px;\n    opacity: 0px;\n\n    font-family: Manrope;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px;\n    text-align: left;\n  }\n\n  .carousel_input {\n    /* width: 434px; */\n    height: 48px;\n    /* top: 483px;\nleft: 150px; */\n    gap: 0px;\n    border-radius: 6px;\n    opacity: 0px;\n    background: #0d2330;\n    border: 1px solid #ffffff;\n\n    .custom_select {\n      background: #0d2330;\n      color: #fff;\n      padding-left: 2.5rem;\n      border-radius: 0.375rem;\n      transition: border-color 0.2s;\n      height: 100%;\n\n      display: flex;\n      align-items: center;\n\n      /* width: 181px; */\n      height: 22px;\n      /* top: 496px;\n            left: 166px; */\n      gap: 0px;\n      opacity: 0px;\n\n      .state {\n        font-family: Manrope;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 21.86px;\n        text-align: center;\n      }\n\n      .country {\n        font-family: Manrope;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 21.86px;\n        text-align: center;\n      }\n    }\n\n    .custom_service_btn {\n      background: #0d2330;\n      color: #fff;\n      padding-left: 2.5rem;\n      border-radius: 0.375rem;\n      transition: border-color 0.2s;\n      height: 100%;\n\n      display: flex;\n      align-items: center;\n\n      /* width: 181px; */\n      height: 22px;\n      /* top: 496px;\n            left: 166px; */\n      gap: 0px;\n      opacity: 0px;\n\n      .text {\n        font-family: Manrope;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: left;\n      }\n    }\n\n    .custom_select:focus {\n      border-color: #34d399;\n      outline: none;\n    }\n\n    .custom_button {\n      cursor: pointer;\n      position: absolute;\n      left: 85%;\n    }\n\n    .icon_location {\n      position: absolute;\n      left: 0.75rem;\n      top: 50%;\n      transform: translateY(-50%);\n      color: #34d399;\n    }\n\n    .icon_down {\n      position: absolute;\n      left: 45%;\n      top: 50%;\n      transform: translateY(-50%);\n      color: #34d399;\n    }\n  }\n}\n\n.carousel .carousel_content .right_content {\n  /* width: 744.67px; */\n  height: 522.54px;\n  position: relative;\n  top: 120px;\n  /* left: 659px; */\n  gap: 0px;\n  opacity: 0px;\n  display: flex;\n  align-items: flex-end;\n\n  img {\n    height: auto;\n  }\n}\n\n.offers_section {\n  .offers_head {\n    h2 {\n      font-family: Manrope;\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 24.59px;\n      text-align: left;\n      color: #1b9075;\n    }\n\n    h1 {\n      font-family: Manrope;\n      font-size: 32px;\n      font-weight: 800;\n      line-height: 32px;\n      letter-spacing: -0.0025em;\n      text-align: center;\n      color: #22263f;\n    }\n  }\n\n  .offers_body_content .card {\n    /* display: flex; */\n    /* gap: 3rem; */\n    /* width: 360px; */\n    height: auto;\n    /* top: 842px;\n        left: 150px; */\n    opacity: 0px;\n    background-color: #e1f5f4;\n\n    .left_content {\n      display: flex;\n      flex-direction: column;\n      /* justify-content: space-between; */\n      align-items: baseline;\n      gap: 1rem;\n\n      .offer_percent {\n        display: flex;\n\n        span {\n          width: 66px;\n          height: 66px;\n          background-color: #0d1b2a;\n          color: white;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 22px;\n          font-weight: 700;\n          font-family: Manrope;\n        }\n\n        sup {\n          font-family: Manrope;\n          font-size: 14px;\n          font-weight: 700;\n          line-height: 32px;\n          text-align: left;\n          color: #000000;\n        }\n      }\n\n      .offer_text {\n        /* width: 206px; */\n        height: auto;\n        top: 939px;\n        left: 166px;\n        gap: 0px;\n        opacity: 0px;\n\n        font-family: Manrope;\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 32px;\n        text-align: left;\n        color: #1b9075;\n      }\n\n      .offer_subtext {\n        height: auto;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Manrope;\n        font-size: 15px;\n        font-weight: 500;\n        line-height: 25px;\n        letter-spacing: 0.25px;\n        text-align: left;\n\n        color: #373737;\n      }\n    }\n\n    .right_content img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      /* top: 850px;\n            left: 324px;\n            gap: 0px;\n            opacity: 0px; */\n    }\n  }\n}\n\n.services_section {\n  /* width: 1144px; */\n  /* height: 579px; */\n  /* top: 1133px;\n    left: 150px; */\n  gap: 0px;\n  opacity: 0px;\n  background: #e7ecf7;\n\n  .service_section_head {\n    h2 {\n      font-family: Manrope;\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 24.59px;\n      text-align: center;\n      color: #1b9075;\n    }\n\n    h1 {\n      font-family: Manrope;\n      font-size: 32px;\n      font-weight: 800;\n      line-height: 32px;\n      letter-spacing: -0.0025em;\n      text-align: center;\n      color: #22263f;\n    }\n  }\n\n  .service_section_body .card {\n    display: flex;\n    flex-direction: column;\n    width: auto;\n    height: auto;\n    /* height: calc(100% - -4rem); */\n    /* top: 1274px;\n        left: 198px; */\n    gap: 0px;\n    opacity: 0px;\n    background-color: #ffffff;\n    position: relative;\n\n    img {\n      /* width: 110.67px;\n      height: 115.12px; */\n      top: 1288px;\n      left: 925px;\n      gap: 0px;\n      opacity: 0px;\n\n      height: 230px;\n      width: 100%;\n      margin-bottom: 10px;\n    }\n\n    .service_body {\n      /* width: 233px; */\n      height: auto;\n      /* top: 1408px;\n            left: 222px; */\n      gap: 0px;\n      opacity: 0px;\n\n      .service_head {\n        width: auto;\n        height: 16px;\n        /* top: 1408px;\n                left: 222px; */\n        gap: 0px;\n        opacity: 0px;\n\n        .first {\n          font-family: Manrope;\n          font-size: 18px;\n          font-weight: 800;\n          line-height: 16px;\n          text-align: left;\n          color: #1b9075;\n        }\n\n        .second {\n          font-family: Manrope;\n          font-size: 18px;\n          font-weight: 700;\n          line-height: 16px;\n          text-align: left;\n          color: #13171b;\n        }\n      }\n\n      .list_services {\n        /* width: 233px; */\n        /* height: 68px; */\n        height: auto;\n        top: 1438px;\n        left: 222px;\n        gap: 10px;\n        opacity: 0px;\n        display: flex;\n        flex-direction: row;\n        gap: 1rem;\n\n        ol {\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          gap: 1rem;\n        }\n\n        ol li {\n          display: flex;\n          align-items: center;\n          /* width: 88px; */\n          height: 18px;\n          /* top: 1488px;\n                    left: 222px; */\n          gap: 10px;\n          opacity: 0px;\n\n          font-family: Manrope;\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 18px;\n          text-align: left;\n          color: #696782;\n        }\n\n        ul {\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          gap: 1rem;\n        }\n\n        ul li {\n          display: flex;\n          align-items: center;\n          /* width: 88px; */\n          height: 18px;\n          /* top: 1488px;\n                    left: 222px; */\n          gap: 10px;\n          opacity: 0px;\n\n          font-family: Manrope;\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 18px;\n          text-align: left;\n          color: #696782;\n        }\n\n        ol li {\n          position: relative;\n          padding-left: 20px;\n          height: auto;\n        }\n\n        ol li::before {\n          content: \"\";\n          position: absolute;\n          left: 0px;\n          top: 50%;\n          width: 7px;\n          height: 7px;\n          border-radius: 50%;\n          background-color: #1b9075;\n          opacity: 1;\n          transform: translateY(-50%);\n        }\n\n        ul li {\n          position: relative;\n          padding-left: 20px;\n          height: auto;\n        }\n\n        ul li::before {\n          content: \"\";\n          position: absolute;\n          left: 0px;\n          top: 50%;\n          width: 7px;\n          height: 7px;\n          border-radius: 50%;\n          background-color: #1b9075;\n          opacity: 1;\n          transform: translateY(-50%);\n        }\n      }\n    }\n\n    .service_button {\n      width: 100%;\n      height: 56px;\n      /* top: 1526px;\n            left: 214px; */\n      padding: 20px;\n      gap: 10px;\n      border-radius: 10px;\n      opacity: 0px;\n      background: #1b9075;\n\n      font-family: Manrope;\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 20px;\n      letter-spacing: 0.02em;\n      text-align: center;\n      color: #fff;\n    }\n  }\n\n  .seeall_button {\n    width: 106px;\n    height: 56px;\n    top: 1628px;\n    left: 667px;\n    /* padding: 20px; */\n    gap: 10px;\n    border-radius: 10px;\n    opacity: 0px;\n    background: #ffffff;\n    border: 1px solid #dce0e4;\n  }\n}\n\n.about_us {\n  /* display: flex; */\n  flex-direction: row;\n  justify-content: space-evenly;\n\n  .about_left_section {\n    /* width: 596px; */\n    width: auto;\n    height: 607.78px;\n    /* height: auto; */\n    top: 1744px;\n    left: 117px;\n    gap: 0px;\n    opacity: 0px;\n  }\n\n  .about_right_section {\n    display: flex;\n    flex-direction: column;\n    /* justify-content: space-between; */\n    width: auto;\n    height: 607.78px;\n    /* top: 1744px;\n        left: 117px; */\n    gap: 11rem;\n    opacity: 0px;\n\n    .about_head {\n      /* width: 481px; */\n      height: 56px;\n      /* top: 1780px;\n            left: 760px; */\n      gap: 0px;\n      opacity: 0px;\n\n      .head {\n        font-family: Manrope;\n        font-size: 42px;\n        font-weight: 700;\n        line-height: 56px;\n        letter-spacing: -0.0025em;\n        text-align: left;\n        color: #22263f;\n\n        span {\n          font-family: Manrope;\n          font-size: 42px;\n          font-weight: 800;\n          line-height: 56px;\n          letter-spacing: -0.0025em;\n          text-align: left;\n          color: #1b9075;\n        }\n      }\n\n      .description {\n        /* width: 500px; */\n        height: 144px;\n        /* top: 1840px;\n                left: 760px; */\n        gap: 0px;\n        opacity: 0px;\n        font-family: Manrope;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: left;\n        color: #545454;\n      }\n    }\n\n    .about_body {\n      width: 324px;\n      height: 40px;\n      /* top: 2005px;\n            left: 761px; */\n\n      div {\n\n        /* width: 324px;\n                height: 40px; */\n        span {\n          width: 262px;\n          height: 24px;\n          /* top: 2012px;\n                    left: 823px; */\n          gap: 0px;\n          opacity: 0px;\n          font-family: Manrope;\n          font-size: 16px;\n          font-weight: 500;\n          line-height: 24px;\n          text-align: left;\n          color: #22263f;\n        }\n      }\n    }\n\n    .about_footer {\n      .footer_btn {\n        width: 153px;\n        height: 56px;\n        /* top: 2221px;\n                left: 761px; */\n        /* padding: 20px; */\n        gap: 10px;\n        border-radius: 10px;\n        opacity: 0px;\n        background: #1b9075;\n      }\n    }\n  }\n}\n\n/* download section */\n\n.download_section {\n  position: relative;\n  background-image: url(\"../../assets/download/downloadSection.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  z-index: 2;\n  /* padding: 1rem; */\n  padding-top: 1rem;\n\n  /* width: 1480.79px; */\n  /* min-height: 616px; */\n  /* top: 52px; */\n  /* left: 0.4px; */\n  gap: 0px;\n  /* border: 1px 0px 0px 0px; */\n  opacity: 0px;\n\n  .download_app_section {\n    width: 100%;\n    height: 495px;\n    top: 2352px;\n    gap: 0px;\n    opacity: 0px;\n\n    display: flex;\n    flex-direction: column;\n\n    .top_content {\n      /* display: flex; */\n      flex-direction: row;\n\n      .left_section {\n        margin-top: 6rem;\n        width: 100%;\n        height: auto;\n\n        h2 {\n          width: 100%;\n          height: auto;\n          /* top: 2448px;\n                    left: 150px; */\n          gap: 0px;\n          opacity: 0px;\n          font-family: Manrope;\n          font-size: 42px;\n          font-weight: 700;\n          line-height: 68px;\n          text-align: left;\n          color: #000000;\n\n          span {\n            font-family: Manrope;\n            font-size: 42px;\n            font-weight: 800;\n            line-height: 68px;\n            text-align: left;\n            color: #ff5555;\n          }\n        }\n\n        div {\n          width: 449.66px;\n          height: 73px;\n          /* top: 2625px;\n                    left: 145px; */\n          padding: 0px;\n          gap: 0px;\n          opacity: 0px;\n        }\n      }\n\n      .right_section {\n        width: auto;\n        height: auto;\n        top: 2426.12px;\n        left: 492px;\n        gap: 0px;\n        opacity: 0px;\n        /* margin-top: -17rem; */\n        /* angle: 21.39 deg; */\n      }\n    }\n\n    .footer_content {\n      width: 100%;\n      /* width: 1280px; */\n      /* width: fit-content; */\n      height: auto;\n      /* top: 2794px;\n            left: 150px; */\n      gap: 1rem;\n      border-radius: 63px;\n      padding: 10px;\n      opacity: 0px;\n      background-color: #fff;\n      box-shadow: 0px 2px 40px 0px #00000029;\n\n      position: relative;\n      top: -45%;\n      /* top: 0%; */\n      left: 0%;\n      display: flex;\n      flex-direction: row;\n      /* justify-content: space-between; */\n\n      .content {\n        width: auto;\n        height: 81px;\n        /* top: 2808px;\n                left: 290px; */\n        gap: 0px;\n        opacity: 0px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n\n        h6 {\n          font-family: Manrope;\n          font-size: 24px;\n          font-weight: 800;\n          line-height: 68px;\n          text-align: left;\n          color: #1b9075;\n        }\n\n        div {\n          font-family: Manrope;\n          font-size: 18px;\n          font-weight: 500;\n          line-height: 22px;\n          text-align: left;\n          color: #474a4c;\n        }\n      }\n\n      .footer_btn {\n        width: 153px;\n        height: 56px;\n        /* top: 2829px;\n                left: 1085px; */\n        padding: 20px;\n        gap: 10px;\n        border-radius: 10px;\n        opacity: 0px;\n        background: #1b9075;\n\n        font-family: Manrope;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 20px;\n        letter-spacing: 0.02em;\n        text-align: center;\n        color: #ffffff;\n        margin: auto 52px auto auto;\n      }\n    }\n  }\n}\n\n/* testimonials section */\n\n.testimonials_section {\n  hr {\n    border: 1px solid #1b9075;\n  }\n\n  .testimonial_head {\n    width: auto;\n    height: auto;\n    /* width: 112px;\n        height: 25px;\n        top: 2991px;\n        left: 664px; */\n    gap: 0px;\n    opacity: 0px;\n    font-family: Manrope;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24.59px;\n    text-align: center;\n    color: #1b9075;\n  }\n\n  .testimonial_desc {\n    width: auto;\n    height: auto;\n    /* width: 466px;\n        height: 32px;\n        top: 3026px;\n        left: 487px; */\n    gap: 0px;\n    opacity: 0px;\n    font-family: Manrope;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 32px;\n    letter-spacing: -0.0025em;\n    text-align: center;\n    color: #22263f;\n  }\n\n  .testimonial_body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .testimonial_rank {\n      width: 104.5px;\n      height: 19px;\n      /* top: 3102px;\n            left: 668px; */\n      gap: 0px;\n      padding: 10px;\n      opacity: 0px;\n\n      border-top: 2px solid #1b9075;\n    }\n\n    .inverted_comma {\n      position: relative;\n      top: -3rem;\n      left: -24rem;\n    }\n\n    .testimonial_text {\n      width: 850px;\n      height: auto;\n      /* height: 296px; */\n      /* top: 3126px;\n            left: 295px; */\n      gap: 0px;\n      opacity: 0px;\n      font-family: Manrope;\n      font-size: 28px;\n      font-weight: 600;\n      line-height: 38.25px;\n      text-align: center;\n      color: #22263f;\n\n      position: relative;\n      top: -6rem;\n      left: 1.5rem;\n    }\n\n    .testimonial_user_section {\n      margin-top: -6rem;\n\n      .active_testimonial {\n        width: 122px;\n        height: 122px;\n        /* top: 3378px;\n                left: 659px; */\n        gap: 0px;\n        opacity: 0px;\n\n        box-shadow: 0px 2px 22px 0px #00000040;\n      }\n\n      .testimonial_user_name {\n        width: 99px;\n        height: 25px;\n        /* top: 3513px;\n                left: 671px; */\n        gap: 0px;\n        opacity: 0px;\n        font-family: Manrope;\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 24.59px;\n        text-align: center;\n        color: #000000;\n      }\n\n      .btn_next {\n        width: 36px;\n        height: 36px;\n        /* top: 3422px;\n                left: 1216px; */\n        gap: 0px;\n        opacity: 0px;\n        background-color: #1b9075;\n        border-radius: 50%;\n        padding: 0rem 0.8rem;\n      }\n\n      .btn_previous {\n        width: 36px;\n        height: 36px;\n        /* top: 3422px;\n                left: 1216px; */\n        gap: 0px;\n        opacity: 0px;\n        background-color: #1b9075;\n        border-radius: 50%;\n        padding: 0rem 0.8rem;\n      }\n    }\n  }\n}\n\n/* service expert section */\n.service_expert {\n  position: relative;\n  /* background-image: url(\"../../assets/home/carousel.svg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat; */\n  z-index: 2;\n  /* padding-top: 1rem; */\n  height: 100%;\n  min-height: auto;\n  gap: 0px;\n\n  .service_expert_section {\n    .left_section {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n\n      .top {\n        width: 100%;\n        height: auto;\n        /* width: 584px; */\n        /* height: 434px;\n                top: 3618px;\n                left: 149px; */\n        gap: 0px;\n        /* border: 1px 0px 0px 0px; */\n        opacity: 0px;\n        /* border: 1px solid #FFFFFF26; */\n\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n\n        .top_head {\n          width: 100%;\n          height: auto;\n          /* width: 372px;\n                    height: 44px; */\n          /* top: 3618px;\n                    left: 149px;\n                    gap: 0px;\n                    opacity: 0px; */\n\n          font-family: Manrope;\n          font-size: 32px;\n          font-weight: 700;\n          line-height: 43.71px;\n          text-align: left;\n\n          span {\n            font-family: Manrope;\n            font-size: 32px;\n            font-weight: 800;\n            line-height: 43.71px;\n            /* text-align: center; */\n            color: #1b9075;\n          }\n        }\n\n        .section_text1 {\n          display: flex;\n          gap: 1rem;\n          padding-bottom: 1rem;\n          border-bottom: 1px solid #1b9075;\n\n          img {\n            background-color: #fff;\n            padding: 1rem;\n            width: 66px;\n            height: 66px;\n            /* top: 3705px;\n                        left: 150px; */\n            gap: 0px;\n            border-radius: 14px;\n            opacity: 0px;\n          }\n\n          div {\n            .service_exp_head {\n              width: 260px;\n              height: 33px;\n              /* top: 3703px;\n                            left: 231px; */\n              gap: 0px;\n              opacity: 0px;\n              font-family: Manrope;\n              font-size: 24px;\n              font-weight: 600;\n              line-height: 32.78px;\n              text-align: left;\n              color: #ffffff;\n            }\n\n            .service_exp_desc {\n              width: 100%;\n              /* width: 502px; */\n              height: 50px;\n              /* top: 3739px;\n                            left: 231px; */\n              gap: 0px;\n              opacity: 0px;\n              font-family: Manrope;\n              font-size: 16px;\n              font-weight: 400;\n              line-height: 21.86px;\n              text-align: left;\n              color: #ffffff;\n            }\n          }\n        }\n\n        .section_text2 {\n          display: flex;\n          gap: 1rem;\n          padding-bottom: 1rem;\n          border-bottom: 1px solid #1b9075;\n\n          img {\n            background-color: #fff;\n            padding: 1rem;\n            width: 66px;\n            height: 66px;\n            /* top: 3705px;\n                        left: 150px; */\n            gap: 0px;\n            border-radius: 14px;\n            opacity: 0px;\n          }\n\n          div {\n            .service_exp_head {\n              width: 260px;\n              height: 33px;\n              /* top: 3703px;\n                            left: 231px; */\n              gap: 0px;\n              opacity: 0px;\n              font-family: Manrope;\n              font-size: 24px;\n              font-weight: 600;\n              line-height: 32.78px;\n              text-align: left;\n              color: #ffffff;\n            }\n\n            .service_exp_desc {\n              /* width: 502px; */\n              width: 100%;\n              height: 50px;\n              /* top: 3739px;\n                            left: 231px; */\n              gap: 0px;\n              opacity: 0px;\n              font-family: Manrope;\n              font-size: 16px;\n              font-weight: 400;\n              line-height: 21.86px;\n              text-align: left;\n              color: #ffffff;\n            }\n          }\n        }\n\n        .section_text3 {\n          display: flex;\n          gap: 1rem;\n          padding-bottom: 1rem;\n\n          img {\n            background-color: #fff;\n            padding: 1rem;\n            width: 66px;\n            height: 66px;\n            /* top: 3705px;\n                        left: 150px; */\n            gap: 0px;\n            border-radius: 14px;\n            opacity: 0px;\n          }\n\n          div {\n            .service_exp_head {\n              width: 260px;\n              height: 33px;\n              /* top: 3703px;\n                            left: 231px; */\n              gap: 0px;\n              opacity: 0px;\n              font-family: Manrope;\n              font-size: 24px;\n              font-weight: 600;\n              line-height: 32.78px;\n              text-align: left;\n              color: #ffffff;\n            }\n\n            .service_exp_desc {\n              /* width: 502px; */\n              width: 100%;\n              height: 50px;\n              /* top: 3739px;\n                            left: 231px; */\n              gap: 0px;\n              opacity: 0px;\n              font-family: Manrope;\n              font-size: 16px;\n              font-weight: 400;\n              line-height: 21.86px;\n              text-align: left;\n              color: #ffffff;\n            }\n          }\n        }\n      }\n\n      .bottom {\n        .bottom_btn {\n          width: 145px;\n          height: 56px;\n          /* top: 4081px;\n                    left: 150px; */\n          padding: 16px;\n          gap: 10px;\n          border-radius: 10px;\n          opacity: 0px;\n          background: #1b9075;\n          color: #fff;\n        }\n      }\n    }\n  }\n}\n\n.service_expert::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: radial-gradient(104% 47.97% at 50% 52.03%,\n      #082b23 0%,\n      #10182f 100%);\n  /* background: radial-gradient(104% 47.97% at 50% 52.03%, #1A9175 0%, #082B23 100%); */\n  opacity: 0.95;\n  pointer-events: none;\n  height: 100%;\n  min-height: auto;\n}\n\n/* blog section */\n.blog_section {\n  .blogs_head {\n    /* width: 49px;\n        height: 25px;\n        top: 4235px;\n        left: 696px;\n        gap: 0px;\n        opacity: 0px; */\n    font-family: Manrope;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24.59px;\n    text-align: left;\n    color: #1b9075;\n  }\n\n  .blogs_desc {\n    /* width: 466px;\n        height: 32px;\n        top: 4267px;\n        left: 487px;\n        gap: 0px;\n        opacity: 0px; */\n    font-family: Manrope;\n    font-size: 32px;\n    font-weight: 800;\n    line-height: 32px;\n    letter-spacing: -0.0025em;\n    text-align: center;\n    color: #22263f;\n  }\n\n  .blog_section_card {\n    .blog_card {\n      width: 100%;\n      height: auto;\n      /* width: 360px;\n            height: 334px; */\n      /* top: 4328px;\n            left: 150px;\n            gap: 0px; */\n      border-radius: 17px;\n      border: 1px;\n      opacity: 0px;\n\n      border: 1px solid #1b9075;\n      box-shadow: 0px 2px 32px 0px #0000001a;\n\n      img {\n        width: 100%;\n        height: auto;\n        /* width: 324px;\n                height: 201px;\n                top: 4346px;\n                left: 168px;\n                gap: 0px; */\n        border-radius: 8px;\n        opacity: 0px;\n      }\n\n      div {\n        width: 100%;\n        /* width: 238px; */\n        /* height: 57px; */\n        /* top: 4583px;\n                left: 168px;\n                gap: 0px;\n                opacity: 0px; */\n\n        h3 {\n          width: auto;\n          height: 25px;\n          /* top: 4583px;\n                    left: 168px;\n                    gap: 0px;\n                    opacity: 0px; */\n          font-family: Manrope;\n          font-size: 18px;\n          font-weight: 700;\n          line-height: 24.59px;\n          text-align: left;\n          color: #000000;\n        }\n\n        div {\n          width: auto;\n\n          /* height: 22px;\n                    top: 4618px;\n                    left: 169px;\n                    gap: 0px;\n                    opacity: 0px; */\n          img {\n            width: 18.72px;\n            height: 19px;\n            /* top: 4619px;\n                        left: 169px;\n                        gap: 0px;\n                        opacity: 0px; */\n          }\n\n          p {\n            font-family: Manrope;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 21.86px;\n            text-align: left;\n          }\n        }\n      }\n    }\n  }\n\n  .blog_button {\n    width: 106px;\n    height: 56px;\n    /* top: 4691px;\n        left: 667px; */\n    padding: 16px;\n    gap: 10px;\n    border-radius: 10px;\n    opacity: 0px;\n    background: #1b9075;\n    color: #fff;\n  }\n}\n\n/* footer css */\n\n.footer_home {\n  position: relative;\n  overflow-x: hidden;\n  /* background-image: url(\"../../assets/home/carousel.svg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat; */\n  z-index: 2;\n\n  .footer_bottom {\n    .company_options {\n      width: 100%;\n      height: 100%;\n      /* width: 298px; */\n      /* height: 162px; */\n      /* top: 4913px;\n            left: 100px; */\n      /* gap: 16px; */\n      border-radius: 12px;\n      opacity: 0px;\n\n      .head {\n        width: 114px;\n        height: 30px;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Lexend;\n        font-size: 24px;\n        font-weight: 500;\n        line-height: 30px;\n        text-align: right;\n        color: #efefef;\n      }\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        width: 298px;\n        height: 116px;\n        gap: 12px;\n        opacity: 0px;\n\n        li {\n          width: 298px;\n          height: 20px;\n          gap: 0px;\n          opacity: 0px;\n          font-family: Lexend;\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 20px;\n          text-align: left;\n          color: #c4c4c4;\n        }\n      }\n    }\n\n    .customer_options {\n      width: 100%;\n      height: 100%;\n      /* width: 298px; */\n      /* height: 162px; */\n      /* top: 4913px;\n            left: 100px; */\n      /* gap: 16px; */\n      border-radius: 12px;\n      opacity: 0px;\n\n      .head {\n        width: 114px;\n        height: 30px;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Lexend;\n        font-size: 24px;\n        font-weight: 500;\n        line-height: 30px;\n        text-align: right;\n        color: #efefef;\n      }\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        width: 298px;\n        height: 116px;\n        gap: 12px;\n        opacity: 0px;\n\n        li {\n          width: 298px;\n          height: 20px;\n          gap: 0px;\n          opacity: 0px;\n          font-family: Lexend;\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 20px;\n          text-align: left;\n          color: #c4c4c4;\n        }\n      }\n    }\n\n    .partner_options {\n      width: 100%;\n      height: 100%;\n      /* width: 298px; */\n      /* height: 162px; */\n      /* top: 4913px;\n            left: 100px; */\n      /* gap: 16px; */\n      border-radius: 12px;\n      opacity: 0px;\n\n      .head {\n        width: 114px;\n        height: 30px;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Lexend;\n        font-size: 24px;\n        font-weight: 500;\n        line-height: 30px;\n        /* text-align: right; */\n        color: #efefef;\n      }\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        width: 298px;\n        height: 116px;\n        gap: 12px;\n        opacity: 0px;\n\n        li {\n          width: 298px;\n          height: 20px;\n          gap: 0px;\n          opacity: 0px;\n          font-family: Lexend;\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 20px;\n          text-align: left;\n          color: #c4c4c4;\n        }\n      }\n    }\n\n    .social_options {\n      width: 100%;\n      height: 100%;\n      /* width: 102px;\n            height: 162px; */\n      /* top: 4913px;\n            left: 100px; */\n      /* gap: 16px; */\n\n      border-radius: 12px;\n      opacity: 0px;\n\n      .head {\n        width: 114px;\n        height: 30px;\n        gap: 0px;\n        opacity: 0px;\n        font-family: Lexend;\n        font-size: 24px;\n        font-weight: 500;\n        line-height: 30px;\n        /* text-align: right; */\n        color: #efefef;\n      }\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        width: 298px;\n        height: 116px;\n        gap: 12px;\n        opacity: 0px;\n\n        li {\n          width: 298px;\n          height: 20px;\n          gap: 0px;\n          opacity: 0px;\n          font-family: Lexend;\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 20px;\n          text-align: left;\n          color: #c4c4c4;\n        }\n      }\n    }\n  }\n}\n\n.footer_home::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: radial-gradient(104% 47.97% at 50% 52.03%,\n      #082b23 0%,\n      #10182f 100%);\n  /* background: radial-gradient(104% 47.97% at 50% 52.03%, #1A9175 0%, #082B23 100%); */\n  /* opacity: 0.95; */\n  pointer-events: none;\n  height: 100%;\n  min-height: auto;\n}\n\n.hero-image {\n  /* background-image: url(''); */\n  background-size: cover;\n  background-position: center;\n}\n\n.testimonial {\n  max-width: 600px;\n  margin: auto;\n}\n\n.offer-card img {\n  transition: transform 0.3s ease-in-out;\n}\n\n.offer-card:hover img {\n  transform: scale(1.05);\n}\n\n.offer-card .discount-badge {\n  top: 0;\n  left: 0;\n  margin-top: 16px;\n  margin-left: 16px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n}\n\n/* media queries */\n@media (min-width: 768px) {\n  .services_section .service_section_body .card .service_button {\n    display: inline-block;\n    /* position: absolute; */\n    left: 0;\n    right: 0;\n    bottom: 20px;\n    /* width: calc(100% - 3rem); */\n    margin: auto;\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 499px) {\n  .carousel .carousel_content {\n    display: grid;\n  }\n\n  .carousel::before {\n    min-height: 100%;\n  }\n\n  .carousel .carousel_content .right_content {\n    top: 0px;\n  }\n\n  .carousel .carousel_content .left_content {\n    height: auto !important;\n  }\n\n  .carousel .carousel_content .left_content .carousel_input .custom_service_btn {\n    padding-left: 0.75rem;\n  }\n\n  .carousel .carousel_content .left_content {\n    .carousel_input {\n      width: 334px;\n    }\n  }\n\n  .carousel .carousel_button {\n    bottom: 6rem;\n  }\n\n  .services_section {\n    padding: 0.25rem;\n  }\n\n  .services_section .seeall_button {\n    margin-bottom: 1rem;\n  }\n\n  .about_us {\n    .about_left_section {\n      height: auto;\n    }\n  }\n\n  .about_us .about_right_section {\n    .about_body {\n      width: auto;\n      margin-top: 6rem;\n    }\n  }\n\n  .about_us .about_right_section .about_body div {\n    justify-content: stretch;\n  }\n\n  .download_section .download_app_section .top_content .left_section div {\n    width: auto;\n    height: auto;\n  }\n\n  .download_section {\n    min-height: 668px;\n  }\n\n  .download_section .download_app_section {\n    height: 100%;\n  }\n\n  .download_section .download_app_section .footer_content .content {\n    height: auto;\n  }\n\n  .download_section .download_app_section .footer_content .content h6 {\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24px;\n  }\n\n  .download_section .download_app_section .footer_content .content div {\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .download_section .download_app_section .footer_content .footer_btn {\n    width: 210px;\n    padding: 5px;\n    font-size: 11px;\n    font-weight: 600;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_text {\n    width: auto;\n    font-size: 20px;\n    left: 0rem;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_user_section .active_testimonial {\n    width: 75px;\n    height: 75px;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_user_section .not_activetestimonials {\n    width: 60px;\n    height: 45px;\n  }\n\n  .testimonials_section .testimonial_body .inverted_comma {\n    width: 75px;\n    height: 150px;\n    position: relative;\n    top: -3rem;\n    left: -9rem;\n  }\n\n  .footer_home .footer_bottom .partner_options ul {\n    height: auto;\n  }\n}\n\n@media (min-width: 500px) and (max-width: 640px) {\n  /* Custom styles for mobile screens */\n\n  .carousel .carousel_content {\n    display: grid;\n  }\n\n  .carousel::before {\n    min-height: 100%;\n  }\n\n  .carousel .carousel_content .right_content {\n    top: 0px;\n  }\n\n  .carousel .carousel_content .left_content {\n    height: auto !important;\n  }\n\n  .carousel .carousel_content .left_content .carousel_input .custom_service_btn {\n    padding-left: 0.75rem;\n  }\n\n  .carousel .carousel_content .left_content {\n    .carousel_input {\n      width: 334px;\n    }\n  }\n\n  .carousel .carousel_button {\n    bottom: 6rem;\n  }\n\n  .about_right_section {\n    .about_body {\n      margin-top: 2rem;\n    }\n  }\n\n  .about_left_section {\n    height: auto !important;\n  }\n\n  .download_section {\n    min-height: 668px;\n  }\n\n  .download_section .download_app_section {\n    height: 100%;\n  }\n\n  .download_section .download_app_section .footer_content .content h6 {\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .download_section .download_app_section .footer_content .content div {\n    font-size: 15px;\n    font-weight: 500;\n  }\n\n  .download_section .download_app_section .footer_content .footer_btn {\n    width: 180px;\n    padding: 10px;\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_text {\n    width: auto;\n    font-size: 20px;\n    left: 0rem;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_user_section .active_testimonial {\n    width: 75px;\n    height: 75px;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_user_section .not_activetestimonials {\n    width: 60px;\n    height: 45px;\n  }\n\n  .testimonials_section .testimonial_body .inverted_comma {\n    width: 75px;\n    height: 150px;\n    position: relative;\n    top: -3rem;\n    left: -11rem;\n  }\n\n  .testimonial p {\n    font-size: 14px;\n  }\n\n  .hero-image {\n    background-position: top;\n  }\n\n  /* Example of modifying Tailwind utilities */\n  .md\\\\:hidden {\n    display: block;\n  }\n\n  .offer-card p {\n    font-size: 14px;\n  }\n\n  .footer_home .footer_bottom .partner_options ul {\n    height: auto;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1024px) {\n  /* Custom styles for tablet screens */\n\n  .carousel .carousel_content .left_content {\n    height: auto !important;\n  }\n\n  .carousel .carousel_content .left_content .carousel_input .custom_service_btn {\n    padding-left: 1rem;\n  }\n\n  .carousel .carousel_content .left_content {\n    width: 50%;\n  }\n\n  .carousel .carousel_content .left_content {\n    .carousel_input {\n      width: 334px;\n    }\n  }\n\n  .about_right_section {\n    justify-content: space-between;\n\n    .about_body {\n      margin-top: 11rem;\n    }\n  }\n\n  .download_section .download_app_section {\n    height: 100%;\n  }\n\n  .download_section .download_app_section .footer_content .content h6 {\n    font-size: 22px;\n    font-weight: 700;\n  }\n\n  .download_section .download_app_section .footer_content .content div {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .download_section .download_app_section .footer_content .footer_btn {\n    width: 160px;\n    padding: 12px;\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_text {\n    width: auto;\n    font-size: 24px;\n    left: 0rem;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_user_section .active_testimonial {\n    width: 80px;\n    height: 80px;\n  }\n\n  .testimonials_section .testimonial_body .testimonial_user_section .not_activetestimonials {\n    width: 70px;\n    height: 50px;\n  }\n\n  .testimonials_section .testimonial_body .inverted_comma {\n    width: 100px;\n    height: 200px;\n    position: relative;\n    top: -3rem;\n    left: -16rem;\n  }\n\n  .testimonial p {\n    font-size: 16px;\n  }\n\n  .offer-card p {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1368px) {\n\n  /* Custom styles for desktop screens */\n  .carousel .carousel_content .left_content {\n    height: auto !important;\n  }\n\n  .about_right_section {\n    .about_body {\n      margin-top: 6rem;\n    }\n  }\n\n  .download_section .download_app_section {\n    height: 100%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .download_section .download_app_section .footer_content {\n    top: -54%;\n  }\n\n  .testimonials_section {\n    margin-top: 4rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .about_right_section .about_body {\n    margin-top: 0;\n  }\n\n  .about_us .about_right_section {\n    height: auto;\n    row-gap: 11rem !important;\n  }\n\n  .about_us {\n    display: flex;\n    flex-direction: column;\n    gap: 7rem;\n  }\n\n  .about_us .about_head .head {\n    margin-bottom: 10px;\n  }\n}\n\n@media (max-width: 640px) {\n  .carousel .carousel_content .right_content {\n    height: auto;\n  }\n\n  .carousel .carousel_content .right_content {\n    top: 50px;\n  }\n\n  .carousel .carousel_content .left_content {\n    width: 100%;\n  }\n}\n\n@media (max-width: 575px) {\n  .about_us {\n    gap: 0rem;\n  }\n\n  .about_us .about_right_section {\n    row-gap: 13rem !important;\n  }\n\n  .offer_head h1,\n  .service_section_head h1,\n  .about_us .about_head .head,\n  .about_us .about_head .head span,\n  .left_section h2,\n  .left_section h2 span,\n  .blog_section h1,\n  .testimonials_section h2 {\n    font-size: 25px !important;\n    line-height: normal !important;\n    text-align: center !important;\n  }\n\n  .left_section span.testimonial_head {\n    text-align: center;\n    display: block;\n  }\n\n  .about_us .about_right_section .about_head .description {\n    text-align: justify;\n  }\n\n  .offers_section .offers_body_content .card .left_content .offer_text {\n    font-size: 18px;\n    line-height: normal;\n  }\n\n  .download_app_section .footer_content {\n    flex-direction: column !important;\n    align-items: center;\n  }\n\n  .download_app_section .footer_content>img {\n    width: 70px;\n  }\n\n  .footer_content .content h6,\n  .footer_content .content>div {\n    text-align: center !important;\n  }\n\n  .service_expert_section .left_section .top img {\n    padding: 5px !important;\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  .service_expert_section .left_section .top>div {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .carousel .carousel_content .left_content .left_content_text {\n    font-size: 25px;\n    line-height: 1.6 !important;\n  }\n\n  .download_section .download_app_section .top_content .left_section {\n    margin-top: 2rem;\n  }\n\n  .download_section {\n    padding-bottom: 50px;\n  }\n\n  .header_company_logo {\n    width: 220px;\n  }\n\n  .offers_section .offers_body_content .card .left_content .offer_percent span {\n    width: 50px;\n    height: 50px;\n    font-size: 16px;\n  }\n\n}\n\n#services{\n  padding-left: 0 !important;padding-right: 0 !important;\n}\n\n/* \n@media (min-width: 320px) {\n  .container{\n    max-width: 100%;\n  }\n\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
